import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

import { CommercialCalculator } from '../Calculators'

import GrossDevelopmentValueForm from './01_GrossDevelopmentValueForm'
import BuildingAndMarketingCost from './02_BuildingAndMarketingCost'
import LandResidualPrice from './03_LandResidualPrice'

export default class Summary extends Component {
  static propTypes = {
    calculator: PropTypes.instanceOf(CommercialCalculator).isRequired,
    data: PropTypes.object.isRequired,
    gotoStage: PropTypes.func.isRequired,
  }

  render() {
    const { calculator, data } = this.props

    const formProps = { calculator, data, readOnly: true }

    return (
      <Fragment>
        <GrossDevelopmentValueForm {...formProps} />
        <div className='review__actions review-actions'>
            <button className='btn btn--link review-actions__btn' onClick={() => this.props.gotoStage(1)}>
              Edit
            </button>
            <div className='review-actions__total'>{calculator.format(calculator.getGrossDevelopmentValue())}</div>
        </div>

        <BuildingAndMarketingCost {...formProps} />
        <div className='review__actions review-actions'>
            <button className='btn btn--link review-actions__btn' onClick={() => this.props.gotoStage(2)}>
              Edit
            </button>
            <div className='review-actions__total'>{calculator.format(calculator.getBuildingCosts())}</div>
        </div>

        <LandResidualPrice {...formProps} />
        <div className='review__actions review-actions'>
            <button className='btn btn--link review-actions__btn' onClick={() => this.props.gotoStage(3)}>
              Edit
            </button>
            <div className='review-actions__total'>{calculator.format(calculator.getProfitAndLandValueCosts())}</div>
        </div>
      </Fragment>
    )
  }
}
